define('bootstrap/bootstrap',[
    'jquery',
    'bootstrap/bootstrap-transition',
    'bootstrap/bootstrap-modal',
    'bootstrap/bootstrap-button',
    'bootstrap/bootstrap-tooltip',
    'bootstrap/bootstrap-dropdown'
], function($) {
    return null;
});

